import TopBar from "@/components/Topbar";
import { DriveContext } from "@/store/DriveContext";
import { useContext, useEffect, useState } from "react";
import MathMainContent from "@/components/MathMainContent";

interface Math {
  operand1: number;
  operator: string;
  operand2: number;
  operator2?: string;
  operand3?: number;
}

interface IOppDetails {
  userId: string;
  username: string;
}

function Fastest() {
  const [loader, setLoader] = useState<boolean>(true);
  const { user } = useContext(DriveContext)!;
  const [question, setQuestion] = useState<Math | null>(null);
  const [ws, setWs] = useState<null | WebSocket>(null);
  const [score, setScore] = useState<number>(0);
  const [oppScore, setOppScore] = useState<number>(0);
  const [oppDetails, setOppDetails] = useState<IOppDetails | null>(null);
  const [oppRating, setOppRating] = useState<number>(0);

  useEffect(() => {
    const wsUrl = "wss://matrix-sggb.onrender.com";
    const socket = new WebSocket(wsUrl);

    socket.onopen = () => {
      console.log("Server connected");
      socket.send(
        JSON.stringify({
          type: "play",
          rating: user?.rating || 0,
          gameName: "fastest",
          userId: user?.userId,
          username: user?.username,
        }),
      );
    };

    socket.onmessage = (msg) => {
      const parsed = JSON.parse(msg.data);
      console.log("In the fastest component", parsed);
      if (parsed.success === false) {
        alert(parsed.message);
        return;
      }

      if (parsed.question) {
        setQuestion(parsed.question);
        return;
      }

      if (parsed.message === "Correct answer" && parsed.questions) {
        setQuestion(parsed.questions);
      }

      if (parsed.success) {
        if (parsed.message === "Waiting for another player to join") {
          setLoader(true);
          return;
        } else if (parsed.message === "Match Found, game starting") {
          setOppDetails({
            userId: parsed.oppDetails.userId,
            username: parsed.oppDetails.username,
          });
          setOppRating(parsed.oppRating);
          setLoader(false);
        }
      }

      if (parsed.yourScore !== undefined && parsed.oppScore !== undefined) {
        setScore(parsed.yourScore);
        setOppScore(parsed.oppScore);
      }
    };

    setWs(socket);

    return () => {
      socket.close();
    };
  }, [user]);

  return (
    <div className="h-[100dvh] bg-[#0a0a12] flex flex-col overflow-hidden relative">
      <TopBar />

      <div className="flex-1 flex flex-col relative z-10 overflow-hidden">
        {loader ? (
          <div className="flex-1 flex flex-col items-center justify-center gap-4 px-6 text-center">
            {/* Custom glowing spinner for dark theme match */}
            <div className="w-12 h-12 border-[3px] border-violet-500/30 border-t-violet-400 rounded-full animate-spin shadow-[0_0_15px_rgba(139,92,246,0.3)]" />
            
            <div className="mt-2">
              <h2 className="text-xl sm:text-2xl font-bold bg-gradient-to-br from-violet-300 to-indigo-100 bg-clip-text text-transparent">Matchmaking Area</h2>
              <p className="text-xs sm:text-[13px] text-gray-500 mt-1 uppercase tracking-widest font-semibold">Waiting for the fastest opponent...</p>
            </div>
          </div>
        ) : question?.operand1 !== undefined ? (
          <MathMainContent
            operand1={question.operand1}
            operator1={question.operator}
            operand2={question.operand2}
            operator2={question.operator2}
            operand3={question.operand3}
            websocket={ws}
            rating={user?.rating || 0}
            setQuestions={setQuestion}
            score={score}
            oppScore={oppScore}
            setScore={setScore}
            setOppScore={setOppScore}
            oppRating={oppRating}
            oppPlayerDetails={oppDetails}
            type="fastest"
          />
        ) : null}
      </div>
    </div>
  );
}

export default Fastest;
